<template>
    <b-card no-body>

        <b-modal id="create-or-update" :title="editing ? 'Güncelle' : 'Oluştur'" no-close-on-esc no-close-on-backdrop>
            <personal-protective-equipment-create-or-update v-model="equipment" :errors="errors"></personal-protective-equipment-create-or-update>
            <template #modal-footer><v-executer :loading="loading" :editing="editing" :action="createOrUpdate"></v-executer></template>
        </b-modal>

        <v-table    ref="table"
                    :add-callback="createNew"
                    :fields="fields"
                    name="personel-protective-equipment"
                    :buttons="buttons"
                    :items-provider="provider"
                    pagination="server"></v-table>

    </b-card>
</template>

<script>
import { BCard } from 'bootstrap-vue'
import PersonalProtectiveEquipmentCreateOrUpdate from './components/PersonalProtectiveEquipmentCreateOrUpdate.vue'
import HumanResourcesParameterApi from '@/api/human-resources-parameters'

export default {
    components:{
        BCard,
        PersonalProtectiveEquipmentCreateOrUpdate
    },
    data(){
        return{
            editing:false,
            errors:{},
            loading:false,
            fields:[
                {name:"Donanım",key:"Name", thClass:"w-50",sortable:true},   
                {name:"Kod",key:"Code", thClass:"w-50",sortable:true},   
            ],
            buttons:[
                { text:"Düzenle",key:"edit",icon:"Edit2Icon",variant:"secondary",action:this.edit },
                { text:"Sil",key:"delete",icon:"TrashIcon",variant:"danger",action:this.delete },
            ],
            equipment:{
                Id:null,
                Name:null,
                Code:null
            }
        }
    },
    methods:{
        clearForm(){
            this.editing = false
            this.equipment.Id = null
            this.equipment.Name = null
            this.equipment.Code = null
        },
        provider(data){
            return HumanResourcesParameterApi.PersonalProtectiveEquipment.Table(data)
        },
        edit(item){
            this.clearForm()
            this.editing = true
            this.equipment.Id = item.Id
            this.equipment.Name = item.Name
            this.equipment.Code = item.Code
            this.$showModal('create-or-update')
        },
        createNew(){
            this.clearForm()
            this.$showModal('create-or-update')
        },
        createOrUpdate(){
            this.loading = true
            HumanResourcesParameterApi.PersonalProtectiveEquipment.CreateOrUpdate(this.editing,this.equipment).then(res=>{
                this.$result(res)
                this.loading = false
                if(res.data.Success){
                    this.$hideModal('create-or-update')
                    this.$refs.table.refresh()
                }
            }).catch(err=>{
                this.loading = false
                this.$result(null,err)
            })
        },
        delete(item){
            this.$confirm('Silmek istediğinize emin misiniz?',`Bu işlem ${item.Name} isimli kişisel koruyucu donanımı silecektir ve geri alınamaz.`).then(result=>{
                if(result){
                    HumanResourcesParameterApi.PersonalProtectiveEquipment.Delete(item.Id).then(res=>{
                        if(res.data.Success) {
                            this.$refs.table.refresh()
                        }
                        this.$result(res)
                    }).catch(err=>{
                        this.$result(null,err)
                    })
                }
            })
        }
    }
}
</script>

<style>

</style>